import {Theme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import useLocalStorageState from 'context/useLocalStorageState';
import React, {useState} from 'react';
import {themeNames, themes} from './themeMain';
import {useToastThemeConfig} from './useToastThemeConfig';

type ThemeName = keyof typeof themeNames;

export const themeContext = React.createContext({
   theme: themes.classic.light as Theme,
   themeName: themeNames.aero as ThemeName,
   setThemeName: (theme: ThemeName) => console.debug('Theme changing is not impelmented'),
   isDark: false as boolean,
   setDark: (dark: boolean) => console.debug('Theme changing mode is not impelmented'),
} as const);

const darkThemeStorageKey = 'darkTheme';
const themeNameStorageKey = 'themeName';
export const useThemeContextBuilder = () => {
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
   // const noPrefersMode = useMediaQuery('(prefers-color-scheme: no-preference)');

   const [themeName, setThemeName] = useLocalStorageState<ThemeName>(
      themeNameStorageKey,
      themeNames.custom
   );
   const [isDark, setDark] = useLocalStorageState<boolean>(darkThemeStorageKey, prefersDarkMode);
   // const isDark = (noPrefersMode && _isDark) || prefersDarkMode;
   // console.debug('dark', isDark, isString(isDark));

   const theme = React.useMemo(() => {
      // console.debug('theme', themeName, isDark);
      if (themeName) {
         return isDark ? themes[themeName].dark : themes[themeName].light;
      }
      return isDark ? themes.classic.dark : themes.classic.light;
   }, [themeName, isDark]);
   // console.debug('teheme', theme);

   useToastThemeConfig(isDark ? 'dark' : 'light');

   return {theme, themeName, setThemeName, isDark, setDark};
};
